import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {AuthProvider} from "./Context/auth-context";
import { BrowserRouter as
Router} from "react-router-dom";
import history from "./pages/history";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';




ReactDOM.render(

    <AuthProvider>
        <Router history={history} forceRefresh={true}>
            <App />
        </Router>
    </AuthProvider>

  ,document.getElementById('root')
);


serviceWorkerRegistration.register();


reportWebVitals();
